import styled from "styled-components";

const SizeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const SizeButton = styled.button`
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: ${(props) => (props.selected ? "#000" : "white")};
  color: ${(props) => (props.selected ? "white" : "#000")};
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  min-width: 40px;

  &:hover {
    border-color: #000;
    background: ${(props) => (props.selected ? "#000" : "#f9f9f9")};
  }
`;

const SizeSelector = ({ selectedSizes, onChange }) => {
  const sizes = ["XS", "S", "M", "L", "XL", "XXL", "XXXL"];

  const toggleSize = (size) => {
    if (selectedSizes.includes(size)) {
      onChange(selectedSizes.filter((s) => s !== size));
    } else {
      onChange([...selectedSizes, size]);
    }
  };

  return (
    <SizeContainer>
      {sizes.map((size) => (
        <SizeButton
          key={size}
          type="button"
          selected={selectedSizes.includes(size)}
          onClick={() => toggleSize(size)}
        >
          {size}
        </SizeButton>
      ))}
    </SizeContainer>
  );
};

export default SizeSelector;
